import { BlockStack, Text } from '@shopify/polaris'

import { AdaptiveModal } from '../common/AdaptiveModal'
import { WorkflowFilter, WorkflowRootFilterType } from '../common/workflow-models'
import { WorkflowFilters, workflowFilterSections } from '../workflow-page/FiltersCard'

export interface SubscriptionFlowFiltersModalProps {
  open: boolean
  onClose: () => any
  filters: WorkflowFilter[]
  rootFilterType: WorkflowRootFilterType
  onChange: (filters: WorkflowFilter[]) => any
  onRootFilterTypeChange: (rootFilterType: WorkflowRootFilterType) => any
}

export const SubscriptionFlowFiltersModal = (props: SubscriptionFlowFiltersModalProps) => {
  return (
    <AdaptiveModal
      title="General flow conditions"
      open={props.open}
      onClose={props.onClose}
      primaryAction={{ content: 'Done', onAction: props.onClose }}
      sectioned
    >
      <BlockStack gap="300">
        {props.filters.length === 0 && (
          <Text as="span" tone="subdued">
            Run workflow unconditionally
          </Text>
        )}
        <WorkflowFilters
          filters={props.filters}
          onChange={props.onChange}
          rootFilterType={props.rootFilterType}
          onRootFilterTypeChange={props.onRootFilterTypeChange}
          workflowFilterOptions={workflowFilterSections(true)}
        />
      </BlockStack>
    </AdaptiveModal>
  )
}
